const app = Voonto.getInstance();

var baseurl = '/ajax/v2/api/v1/';
const vocUserNotificationsPath = app.lookup('vocento.config.nibara').vocUserNotifications;
let host = window.location.host;
if (vocUserNotificationsPath !== undefined) {
    baseurl = vocUserNotificationsPath + baseurl;
} else if ('abcblogs.abc.es' === host) {
    baseurl = 'https://www.abc.es' + baseurl;
}

var checkNotifications = false;

function notificationsLoad() {
    countNotifications();

    Voonto.$('.bloque-notificaciones, .notificaciones-capa').on('click', '.delete',function (ev) {
        ev.preventDefault();
        let id = Voonto.$(this).data('id');
        let ids = [];
        ids.push(id);
        deleteNotifications(ids);
    });

    Voonto.$('.bloque-notificaciones, .notificaciones-capa').on('click', '.cuerpo-notificacion .titulo a',function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        let id = Voonto.$(this).data('id');
        let status = Voonto.$(this).data('status');
        let url = Voonto.$(this).attr('href');
        let ids = [];
        ids.push(id);
        if((status != 'read')&&(ids.length > 0)){
            confirmClickedUrl(ids,url,status) ;
        }else{
            window.location.href = url;
        }
    });

}

function countNotifications(){

  Voonto.$.ajax({
    url: baseurl + 'notifications/count',
    dataType: 'json',
    xhrFields: {
      withCredentials: true
    },
    timeout: 10000
    }).fail(function(jqXHR, textStatus, errorThrown) {
      Logger.error('count notifications: retrieve', textStatus);
    }).done(function (response) {
      if(response && 'undefined' !== typeof response.code && response.code === 200){
        if(response.count > 0){
          Logger.debug('[vocuser-notifications] count notifications', response.count);
          Voonto.$('.user-logged-in > .alertas.notificaciones').append('<span class="globo">'+response.count+'</span>');
        }
      }else{
        Logger.error('[vocuser-notifications] count notifications', response);
      }
    });
}

function countNotificationsR2(){
    let daysRecents = 5;
    let today = new Date();
    let dateRecents = new Date(today.getTime() - (daysRecents * 24 * 3600 * 1000));
    Logger.debug('[post-script] Count notifications R2');
    Logger.debug('[post-script] baseurl: ' + baseurl + 'notifications/list');
    Voonto.$.ajax({
        url: baseurl + 'notifications/list',
        dataType: 'json',
        xhrFields: {
            withCredentials: true
        },
        timeout: 10000
    }).fail(function(jqXHR, textStatus, errorThrown) {
        Logger.error('count notifications: retrieve', textStatus);
    }).done(function (response) {
        if(response && 'undefined' !== typeof response.code && response.code === 200){
            if(response.list.length > 0){
                Logger.debug('[vocuser-notifications] count notifications all', response.list.length);
                let recientes = [];
                response.list.forEach(function (notification) {
                    let notDate = notification['timestamp'].split(/[^0-9]/);
                    let notificationDate = new Date (notDate[0],notDate[1]-1,notDate[2],notDate[3],notDate[4],notDate[5]);
                    if (dateRecents <= notificationDate && notification['status'] === 'received') {
                        recientes.push(notification);
                    }
                });
                Logger.debug('[vocuser-notifications] count notifications recents', recientes.length);
                if(recientes.length > 0){
                    Voonto.$('.user-logged-in > .alertas.notificaciones').append('<span class="globo">'+recientes.length+'</span>');
                }
            }
        }else{
            Logger.error('[vocuser-notifications] count notifications', response);
        }
    });
}

function confirmNotifications(notifications, statusNotif){

    let events = [];
    let status = '';

    if(notifications.length > 0){
        events = notifications;
        status = statusNotif;
    }else{
        /* confirmamos todas las notificaciones, enviamos el id de una para recibir el request no vacio */
        let event = '0000';
        events.push(event);
        status = 'received,read';
    }

    let data = {
        'notifications':events,
        'status': status,
        'all': 0
    };
    Logger.debug('[vocuser-notifications] confirm notifications ' + status, data);

    Voonto.$.ajax({
        type: 'post',
        url: baseurl + 'notifications/confirm',
        data: data,
        dataType: 'json',
        xhrFields: {
            withCredentials: true
        },
        timeout: 10000
    }).fail(function(jqXHR, textStatus, errorThrown) {
        Logger.error('confirm notifications: retrieve', textStatus);
    }).done(function (response) {
        if(response && 'undefined' !== typeof response.code && response.code === 200){
            Logger.debug('[vocuser-notifications] confirm notifications OK');
            Voonto.$('.user-logged-in > .alertas.notificaciones, .todas-notificaciones').find('.globo, .nuevo').remove();
        }else{
            Logger.error('[vocuser-notifications] confirm notifications', response);
        }
    });
}

function listNotifications() {
    let hitsMenu = 4;
    let daysRecents = 5;
    let today = new Date();
    let dateRecents = new Date(today.getTime() - (daysRecents * 24 * 3600 * 1000));

    return new Promise((resolve, reject) => {

        app.when('vocuser:ready').then((gigyaUX) => {
            Logger.debug('[vocuser-notifications listNotifications] gigyaUX');
            let userType = gigyaUX.getUserType();
            if (userType !== 'anonimo') {

                Voonto.$.ajax({
                    url: baseurl + 'notifications/list',
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    },
                    timeout: 10000
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    Logger.error('list notifications: retrieve', textStatus);
                    return reject(textStatus);
                }).done(function (response) {
                    if (response && 'undefined' !== typeof response.code && response.code === 200) {
                        Logger.debug('[vocuser-notifications listNotifications] response',response);
                        let notificationsUrl = [];
                        let notificationsNoUrl = [];
                        let $list = Voonto.$('.login-alerta > .notificaciones-capa');
                        $list.children().remove();
                        if (response.list.length > 0) {
                            let recientes = [];
                            let anteriores = [];
                            response.list.forEach(function (notification) {
                                if(notification['status'] == 'received'){
                                    if (notification['content']['url'] != ''){
                                        notificationsUrl.push(notification['id']);
                                    }else{
                                        notificationsNoUrl.push(notification['id']);
                                    }
                                }
                            });
                            response.list.slice(0,hitsMenu*2).forEach(function (notification) {
                                let notDate = notification['timestamp'].split(/[^0-9]/);
                                let notificationDate = new Date (notDate[0],notDate[1]-1,notDate[2],notDate[3],notDate[4],notDate[5]);
                                if (dateRecents <= notificationDate) {
                                    recientes.push(notification);
                                } else {
                                    anteriores.push(notification);
                                }
                            });
                            if(recientes.length > 0) {
                                $list.append('<section class="zona-notificaciones">' +
                                    '<h4 class="subtitulo-area">Recientes</h4>' +
                                    '<span class="bloque-notificaciones">'
                                );
                                recientes.slice(0,hitsMenu).forEach(function (notification) {
                                    displayNotification($list.find('.bloque-notificaciones'), notification);
                                });
                                $list.append('</span></section>');
                            }
                            if(anteriores.length > 0 && recientes.length < hitsMenu) {
                                $list.append('<section class="zona-notificaciones secundario">' +
                                    '<h4 class="subtitulo-area secundario">Anteriores</h4>' +
                                    '<span class="bloque-notificaciones">'
                                );
                                let items = recientes.length;
                                anteriores.slice(0,hitsMenu).forEach(function (notification) {
                                    if(items < hitsMenu){
                                        displayNotification($list.find('.secundario .bloque-notificaciones'), notification);
                                        items = items + 1;
                                    }
                                });
                                $list.append('</span></section>');
                            }

                            $list.append(
                                '<span class="botonera derecha">' +
                                    '<a class="boton" href="/micuenta/notificaciones/">' +
                                        '<span class="accion">Ver todas</span>' +
                                        '<span class="icono">' +
                                            '<svg viewBox="0 0 24 24"><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path></svg>' +
                                        '</span>' +
                                    '</a>' +
                                '</span>'
                            );
                        } else {
                            $list.append(
                                '<span class="notificacion fecha">No tienes ninguna notificación pendiente</span>'
                            );
                        }
                        if (notificationsUrl.length > 0){
                            confirmNotifications(notificationsUrl, 'received,pending');

                        }
                        if (notificationsNoUrl.length > 0){
                            confirmNotifications(notificationsNoUrl, 'received,read');
                        }
                        return resolve();
                    }else{
                        Logger.error('[vocuser-notifications] list notifications', response);
                        return reject('Invalid response');
                    }
                });
            }else{
                return resolve();
            }
        });

        function displayNotification($list, notification) {
            let type = '';
            let mchannel, source, linkname, vtmInfo = '';
            let title = 'Noticia';
            if(notification['content']['contentType'] == 'concurso' || notification['content']['contentType'] == 'evento'){
                type = 'evento';
                title = 'Concurso';
            }else if(notification['content']['contentType'] == 'encuesta'){
                type = 'encuesta';
                title = 'Encuesta';
            }
            if(notification['content']['url'].includes('/opinion/')) {
                title = 'Opinión';
            }
            if(notification['content']['contentType'] == 'noticia'){
                mchannel = 'autor';
            }else{
                mchannel = 'manual';
            }
            if(mchannel == 'autor'){
                source = notification['content']['categoryId'];
                linkname = notification['content']['author']['name'].toLowerCase().replace(/[^a-zA-Z0-9]+/g,'-');
                vtmInfo = mchannel+'-'+linkname;
            }else{
                source = notification['content']['contentId'];
                linkname = notification['content']['contentType'];
                vtmInfo = mchannel+'-'+source+'-'+linkname;
            }
            let tagging = '#ns_campaign=area-usuario-notif&ns_mchannel=' + mchannel + '&ns_source=' + source + '&ns_linkname=' + linkname + '&ns_fee=0';
            let authorBottom = '';

            if (notification['content'].hasOwnProperty('interests') && (notification['content']['interests'].length > 0)){
                if (notification['content']['interests'][0]['name'] !== ''){
                    authorBottom = notification['content']['interests'][0]['name'];
                }else if(notification['content']['interests'][0]['subcategory_name'] != 'General'){
                    authorBottom = notification['content']['interests'][0]['category_name'] + ' - ' + notification['content']['interests'][0]['subcategory_name'];
                }else{
                    authorBottom = notification['content']['interests'][0]['category_name'];
                }
            }
            if(notification['content']['url'] != '') {
                $list.append(
                    '<article class="tarjeta-notificacion'+ (notification['status'] !== 'read' ? ' nueva' : '') + (notification['content']['url'].includes('/opinion/') ? ' opinion' : '') + (type != '' ? ' '+type : '') +'">' +
                    '<header><span class="tipo">'+ title +'</span><span class="interes">' + ((authorBottom != '')?('en '+ authorBottom):('por '+ notification['content']['author']['name'])) +'</span></header>' +
                    '<span class="cuerpo-notificacion">' +
                    '<h5 class="titulo"><a data-id="' + notification['id'] + '" data-status="' + notification['status'] + '" href="' + notification['content']['url'] + tagging + '" title="' + notification['content']['title'] + '" data-voc-vtm-id="au-notific-click" data-voc-vtm-info="' + vtmInfo + '">' + notification['content']['title'] + '</a></h5>' +
                    ((authorBottom != '')?('<span class="data">' + notification['content']['author']['name'] + '</span>'):'') +
                    '</span>' +
                    '<footer>' +
                    '<span class="fecha">' + dateFormat(notification['timestamp']) + '</span>' +
                    '<span class="boton">' +
                    '<span class="accion delete" data-id="' + notification['id'] + '" data-voc-vtm-id="au-notific-eliminar" data-voc-vtm-info="' + vtmInfo + '">Eliminar</span>' +
                    '</span>' +
                    '</footer>' +
                    '</article>'
                );
            }else{
                $list.append(
                    '<article class="tarjeta-notificacion'+ (notification['status'] !== 'read' ? ' nueva' : '') + (notification['content']['url'].includes('/opinion/') ? ' opinion' : '') + (type != '' ? ' '+type : '') +'">' +
                    '<header><span class="tipo">'+ title +'</span><span class="interes">' + ((authorBottom != '')?('en '+ authorBottom):('por '+ notification['content']['author']['name'])) +'</span></header>' +
                    '<span class="cuerpo-notificacion">' +
                    '<h5 class="titulo">' + notification['content']['title'] + '</h5>' +
                    ((authorBottom != '')?('<span class="data">' + notification['content']['author']['name'] + '</span>'):'') +
                    '</span>' +
                    '<footer>' +
                    '<span class="fecha">' + dateFormat(notification['timestamp']) + '</span>' +
                    '<span class="boton">' +
                    '<span class="accion delete" data-id="' + notification['id'] + '" data-voc-vtm-id="au-notific-eliminar" data-voc-vtm-info="' + vtmInfo + '">Eliminar</span>' +
                    '</span>' +
                    '</footer>' +
                    '</article>'
                );
            }
        }

        function dateFormat(fecha) {
            if (Voonto.is.safari()) {
                fecha = fecha.replace(/(\+\d\d)(\d\d)/,function(a,b,c){return b + ':' + c;});
            }

            let date = new Date(fecha);
            Number.prototype.padLeft = function(base,chr){
                var  len = (String(base || 10).length - String(this).length)+1;
                return len > 0? new Array(len).join(chr || '0')+this : this;
            }
            let dformat = [date.getDate().padLeft(),
                    (date.getMonth()+1).padLeft(),
                    date.getFullYear()].join('-') + ' ' +
                [date.getHours().padLeft(),
                    date.getMinutes().padLeft(),
                    date.getSeconds().padLeft()].join(':');

            return dformat;
        }
    });
}

function deleteNotifications(ids){
    let data = {'notifications':ids};
    Logger.debug('[vocuser-notifications] delete notifications', data);

    Voonto.$.ajax({
        type: 'post',
        url: baseurl + 'notifications/delete',
        data: data,
        dataType: 'json',
        xhrFields: {
            withCredentials: true
        },
        timeout: 10000
    }).fail(function(jqXHR, textStatus, errorThrown) {
        Logger.error('delete notifications: retrieve', textStatus);
    }).done(function (response) {
        if(response && 'undefined' !== typeof response.code && response.code === 200){
            Logger.debug('[vocuser-notifications] delete notifications OK');
            ids.forEach(function (id) {
                Voonto.$('.bloque-notificaciones [data-id='+id+']').closest('article').remove();
            });
            checkNotificationsEmpty();
        }else{
            Logger.error('[vocuser-notifications] delete notifications', response);
        }
    });
}

function confirmClickedUrl(ids, url, status){

    let data = {
        'notifications':ids,
        'status' : status + ',read',
        'all': 0
    };
    Logger.debug('[vocuser-notifications] confirm clicked url', data);

    Voonto.$.ajax({
        type: 'post',
        url: baseurl + 'notifications/confirm',
        data: data,
        dataType: 'json',
        xhrFields: {
            withCredentials: true
        },
        timeout: 10000
    }).fail(function(jqXHR, textStatus, errorThrown) {
        Logger.error('confirm clicked url: retrieve', textStatus);
    }).done(function (response) {
        if(response && 'undefined' !== typeof response.code && response.code === 200){
            Logger.debug('[vocuser-notifications] confirm clicked url OK');
            window.location.href = url;
        }else{
            Logger.error('[vocuser-notifications] delete notifications', response);
        }
    });

}

function checkNotificationsEmpty() {
    let $list = Voonto.$('.notificaciones-capa');
    let $listwebpage = Voonto.$('.completa').last();
    Logger.debug('[vocuser-notifications] checkNotificationsEmpty', $list);

    if ($list.find('.bloque-notificaciones').children('article').length === 0 ) {
        $list.children().remove();
        $list.append(
            '<span class="notificacion fecha">No tienes ninguna notificación pendiente</span>'
        );
    }
    if($listwebpage.find('.bloque-notificaciones').children('article').length === 0 ) {
        $listwebpage.find('.bloque-notificaciones').closest('.completa').children().remove();
        Logger.debug('[vocuser-notifications] checkNotificationsEmpty webpage', $listwebpage.length);
        $listwebpage.append(
            '<span class="mensaje">No tienes ninguna notificación pendiente</span>'
        );
    }
}

export {notificationsLoad,listNotifications};



// WEBPACK FOOTER //
// ./src/scripts/layout/vocuser-notifications.js